import { Button, Heading, Icon } from '@dittolive/anvil'
import { FunnelSimpleXIcon } from '@phosphor-icons/react'
import upperFirst from 'lodash/upperFirst'
import React from 'react'

import type { LiveQueryDataBridge } from '../../../types/dataBridge'

type Props = {
  /**
   * The data bridge to display
   */
  dataBridge: LiveQueryDataBridge
  /**
   * Click handler for the row
   */
  onClick?: () => void
}

export default function DataBridgeTableRowContent({
  dataBridge,
  onClick,
}: Props) {
  const isKafkaFirehose =
    !dataBridge.source.collection && dataBridge.destinationKind === 'kafka'
  const isOQBDialect = dataBridge.source.dialect === 'OQB'

  return (
    <Button
      variant="ghost"
      type="button"
      onClick={onClick}
      data-testid="dataBridgesTableRow"
      className="hover:bg-background-surface-secondary flex h-full w-full items-start justify-between p-4 text-left normal-case transition-colors"
    >
      <div className="flex h-full flex-col space-y-1">
        <Heading level={3} className="text-base sm:text-base">
          {dataBridge.description || 'Data Bridge'}
        </Heading>
        <p className="text-foreground-subtle font-mono text-base leading-5">
          {upperFirst(dataBridge.destinationKind || '')}
        </p>
      </div>

      {(isKafkaFirehose || isOQBDialect) && (
        <div className="flex flex-col gap-y-3">
          {isKafkaFirehose && (
            <div
              className="flex items-center gap-1"
              data-testid="unfilteredAnnotation"
            >
              <Icon
                svg={<FunnelSimpleXIcon />}
                className="text-foreground-subtle size-4 shrink-0"
              />
              <span className="text-foreground-normal text-base">
                Unfiltered
              </span>
            </div>
          )}

          {isOQBDialect && !isKafkaFirehose && (
            <div
              className="bg-fill-warning-secondary flex items-center justify-center rounded-md px-2 py-0.5"
              data-testid="oqbAnnotation"
            >
              <span className="text-foreground-normal text-base">Legacy</span>
            </div>
          )}
        </div>
      )}
    </Button>
  )
}
